"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AbstractAnimationValue_1 = require("../properties/AbstractAnimationValue");
var AnimationValue = (function (_super) {
    tslib_1.__extends(AnimationValue, _super);
    function AnimationValue(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    return AnimationValue;
}(AbstractAnimationValue_1.AbstractAnimationValue));
exports.AnimationValue = AnimationValue;
//# sourceMappingURL=AnimationValue.js.map